module.exports = __webpack_public_path__ + "media/images/help/browse_img_5-903f288be96d87030b4d2ea05c0ebc45.jpeg";